import { render, staticRenderFns } from "./scoreDialog.vue?vue&type=template&id=157c6288"
import script from "./scoreDialog.vue?vue&type=script&lang=js"
export * from "./scoreDialog.vue?vue&type=script&lang=js"
import style0 from "./scoreDialog.vue?vue&type=style&index=0&id=157c6288&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports